// src/utils/color.js
// Picks a readable text colour (near-black or near-white) for a given
// background colour, via perceived luminance (WCAG-ish, not exact) - used
// for the fallback "Homework Solutions" header text when a tutor sets a
// custom header colour but hasn't uploaded a logo for that role, so the
// text stays legible regardless of how light or dark they pick.
export function getContrastTextColor(hexColor, { light = '#ecf0f1', dark = '#2c3e50' } = {}) {
  if (!hexColor) return dark;
  const hex = hexColor.replace('#', '');
  const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
  if (full.length !== 6) return dark;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return dark;
  // Perceived brightness (ITU-R BT.601)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 150 ? dark : light;
}
